import { C } from "../../shared/theme";

// One "this task is for…" dropdown in the task editor (Goal, Key date, Dream, Fear): its label, "No …" then `options`
// ({ id, label }), and `children` under it (a Key Date's hint). onChange gets the id, or null for none.
export function TaskLinkField({ id, label, none, options, value, onChange, children }) {
  return (
    <div style={{ padding: "12px 0", borderTop: `1px solid ${C.border}` }}>
      <label htmlFor={id} style={{ display: "block", fontSize: 11, fontWeight: 700, color: C.textDim, letterSpacing: "0.07em", textTransform: "uppercase", marginBottom: 8 }}>
        {label} <span style={{ fontWeight: 400, textTransform: "none", letterSpacing: 0 }}>(optional)</span>
      </label>
      <select id={id} value={value || ""} onChange={e => onChange(e.target.value || null)}
        style={{ width: "100%", background: C.surface2, border: `1px solid ${C.border}`, borderRadius: C.rsm, minHeight: 44, padding: "10px 12px", fontSize: 16, color: value ? C.text : C.textMid, fontFamily: "inherit", outline: "none" }}>
        <option value="">{none}</option>
        {options.map(o => <option key={o.id} value={o.id}>{o.label}</option>)}
      </select>
      {children}
    </div>
  );
}
